<template>
	<div class="pa-6">
		<Loader :messageSelector="messageSelector" :overlay="overlay" />

		<fieldset class="text-h5 text-sm-h4">
			<legend>Imposition</legend>
			<div class="legalSection">
				<h2>Veuillez déposer vos documents reliés à l'imposition</h2>
				<Attachment ref="impositionAttachment"
										file-prefix="exigence"
										@completeEvent="saveNextAttachment"></Attachment>
			</div>
		</fieldset>
			<v-btn color="primary" @click="saveAndExit()">Sauvegarder et fermer</v-btn>
	</div>
</template>

<script>
	import { mapActions, mapGetters, mapMutations } from "vuex";
	import Loader from "../Loader";
	import Attachment from "../attachments/Attachment";
  import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin"

	export default {
    mixins: [AttachementFormulaireMixin],
    components: {
			Attachment,
			Loader,
		},
		data () {
			return {
        messageSelector: null,
				overlay: false,
			};
		},
		computed: {
			...mapGetters({
				contactId: "DemandeAdmission/GET_CONTACTID",
			}),
		},
		created () {
			this.fetchItems()
		},
		methods: {
			...mapMutations({
			}),
			...mapActions({
				getDocumentsByContactId: "Documents/getDocumentsByContactId",
			}),
			async fetchItems () {
				try {
					this.messageSelector = "Loading"
					this.overlay = true

					if (this.contactId) {
						await this.getDocumentsByContactId(this.contactId)
					}

          // Liste les uploads de fichiers
          this.refsUpload = [
            () => this.$refs.impositionAttachment,
          ]
				} catch (erreur) {
					console.log(erreur)
				}
			},
			saveAndExit () {
				this.redirectValue = "exit"
				this.save()
			},
			save () {
				this.messageSelector = "Save"
				this.overlay = true

        this.saveAttachments(
            "contact",
            this.contactId,
            () => {
              this.overlay = false
              this.redirect()
            })
			},
			redirect () {
				if (this.redirectValue == "exit") {
					window.top.location.reload()
				}
			},
		},
	};
</script>

<style>
</style>